var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7668 15.0781L28.4974 18.1793C30.0593 20.9779 29.4324 24.6492 26.9724 27.1092C26.9724 27.1092 23.9889 30.0932 29.3985 35.503C34.8065 40.911 37.7924 37.9292 37.7924 37.9292C40.2524 35.4692 43.9236 34.8422 46.7222 36.4041L49.8233 38.1348C54.0494 40.4932 54.5484 46.4196 50.834 50.1342C48.602 52.3662 45.8676 54.103 42.8449 54.2174C37.7566 54.4105 29.1153 53.1228 20.447 44.4545C11.7789 35.7862 10.4911 27.1449 10.684 22.0566C10.7986 19.034 12.5353 16.2996 14.7673 14.0676C18.4819 10.3531 24.4083 10.8522 26.7668 15.0781Z",
    stroke: "white",
    strokeWidth: 5.33,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.a73f1850cb64336172dfc00236f3d800.svg";
export { ForwardRef as ReactComponent };